import { Box, BoxProps } from "@material-ui/core";

const Form = (props: BoxProps) => {
  return <Box maxWidth={600} {...props} />;
};

export default Form;
